import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import * as forge from 'node-forge';
import { globalVariable } from '../globalVariable/globalvariable';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(private http: HttpClient) { }

  callingpublickey(): Observable<any> {
    return this.http.post(environment.APIEndpoint + "/api/trust/loginui/fetchPublicKey", '');

  }

  rsaencryption(text: any) {
    const publicKeyBase64 = globalVariable.publickey;
    const publicKey = forge.pki.publicKeyFromPem(`-----BEGIN PUBLIC KEY-----\n${publicKeyBase64}\n-----END PUBLIC KEY-----`);
    const encrypted = forge.util.encode64(publicKey.encrypt(text));
    return encrypted;
  }

  encriptionMethodnewRSAandAES(value: any) {
    const key = CryptoJS.lib.WordArray.random(8).toString();
    const iv = CryptoJS.lib.WordArray.random(8).toString();
    const cipher = forge.cipher.createCipher('AES-GCM', key);
    cipher.start({
      iv: iv,
      additionalData: 'nvn', // optional
      tagLength: 128 // optional, defaults to 128 bits
    });
    cipher.update(forge.util.createBuffer(value));
    cipher.finish();
    const encrypted = cipher.output;
    const encodedB64 = forge.util.encode64(encrypted.data);
    const tag = cipher.mode.tag;
    const tagB64 = forge.util.encode64(tag.data);
    const encryptedvalue = encodedB64;

    const body = {
      "encryptedvalue": encryptedvalue,
      "key": this.rsaencryption(key),
      "iv": this.rsaencryption(iv),
      "tag": this.rsaencryption(tagB64)
    }
    return body;

  }

  validateLogin(newItem: any, context: any): Observable<any> {
    var Body = "Just Empty Value"
    var body = {
      "newItem": newItem,
      "context": context
    }
    var body2 = this.encriptionMethodnewRSAandAES(JSON.stringify(body))
    return this.http.post(environment.APIEndpoint + "/api/trust/loginui/doLogin", body2, {
      responseType: 'json'
    })
  }
  doLogout(): Observable<any> {

    var body = {

      "context": "To logout"
    }

    var body2 = this.encriptionMethodnewRSAandAES(JSON.stringify(body))

    return this.http.post(environment.APIEndpoint + "/api/trust/loginui/doLogout", body2, { responseType: 'json' });
  }

  downloadpdffile(doc_id: any): Observable<any> {

    var body = {

      "context": "To logout",
      "doc_id": doc_id,
      "user_uuid": sessionStorage.getItem("uuid"),
      "role_name": sessionStorage.getItem("role_name")
    }

    var body2 = this.encriptionMethodnewRSAandAES(JSON.stringify(body))

    return this.http.post(environment.APIEndpoint + "/api/trust/master/fetchcontenet", body2, { responseType: 'json' });
  }

  downloadpdffile2(doc_id: any): Observable<any> {

    var body = {

      "context": "To logout",
      "doc_id": doc_id,
      "user_uuid": sessionStorage.getItem("uuid"),
      "role_name": sessionStorage.getItem("role_name")
    }

    var body2 = this.encriptionMethodnewRSAandAES(JSON.stringify(body))

    return this.http.post(environment.APIEndpoint + "/api/trust/master/fetchPasswordPdf", body2, { responseType: 'json' });
  }

  fetchDocumentType(): Observable<any> {

    var body = {

      "context": "To logout",
      "user_uuid": sessionStorage.getItem("uuid"),
      "role_name": sessionStorage.getItem("role_name")
    }

    var body2 = this.encriptionMethodnewRSAandAES(JSON.stringify(body))

    return this.http.post(environment.APIEndpoint + "/api/trust/master/fetchDocumentType", body2, { responseType: 'json' });
  }

  fetchPublicDocumentType(context: any): Observable<any> {

    if (context == 'Inside Trust') {
      var body = {

        "context": "To logout",
        "outsideorInsidechecker": context,
        "user_uuid": sessionStorage.getItem("uuid"),
        "role_name": sessionStorage.getItem("role_name")
      }
    } else if (context == 'Outside trust') {
      var body = {

        "context": "To logout",
        "outsideorInsidechecker": context,
        "user_uuid": "NA",
        "role_name": "NA"
      }
    }

    var body2 = this.encriptionMethodnewRSAandAES(JSON.stringify(body))

    return this.http.post(environment.APIEndpoint + "/api/trust/master/fetchPublicDocumentType", body2, { responseType: 'json' });
  }



  fetchDocumentVisibility(): Observable<any> {

    var body = {

      "context": "To logout",
      "user_uuid": sessionStorage.getItem("uuid"),
      "role_name": sessionStorage.getItem("role_name")
    }

    var body2 = this.encriptionMethodnewRSAandAES(JSON.stringify(body))

    return this.http.post(environment.APIEndpoint + "/api/trust/master/fetchDocumentVisibility", body2, { responseType: 'json' });
  }

  fetchDocumenttypetabledata(): Observable<any> {

    var body = {

      "context": "To logout",
      "user_uuid": sessionStorage.getItem("uuid"),
      "role_name": sessionStorage.getItem("role_name")
    }

    var body2 = this.encriptionMethodnewRSAandAES(JSON.stringify(body))

    return this.http.post(environment.APIEndpoint + "/api/trust/master/fetchDocumenttypetabledata", body2, { responseType: 'json' });
  }

  fetchDocumenttableData(): Observable<any> {

    var body = {

      "context": "To logout",
      "user_uuid": sessionStorage.getItem("uuid"),
      "role_name": sessionStorage.getItem("role_name")
    }

    var body2 = this.encriptionMethodnewRSAandAES(JSON.stringify(body))

    return this.http.post(environment.APIEndpoint + "/api/trust/master/fetchDocumenttableData", body2, { responseType: 'json' });
  }

  fetchTenanttabledata(): Observable<any> {

    var body = {

      "context": "To logout",
      "user_uuid": sessionStorage.getItem("uuid"),
      "role_name": sessionStorage.getItem("role_name")
    }

    var body2 = this.encriptionMethodnewRSAandAES(JSON.stringify(body))

    return this.http.post(environment.APIEndpoint + "/api/trust/master/fetchTenanttabledata", body2, { responseType: 'json' });
  }

  fetchUserstabledata(): Observable<any> {

    var body = {

      "context": "To logout",
      "user_uuid": sessionStorage.getItem("uuid"),
      "role_name": sessionStorage.getItem("role_name")
    }

    var body2 = this.encriptionMethodnewRSAandAES(JSON.stringify(body))

    return this.http.post(environment.APIEndpoint + "/api/trust/master/fetchUserstabledata", body2, { responseType: 'json' });
  }

  InsertDoctypedata(formdata: any): Observable<any> {

    var body = {

      "context": "To logout",
      "user_uuid": sessionStorage.getItem("uuid"),
      "formdata": JSON.stringify(formdata),
      "role_name": sessionStorage.getItem("role_name")
    }

    var body2 = this.encriptionMethodnewRSAandAES(JSON.stringify(body))

    return this.http.post(environment.APIEndpoint + "/api/trust/master/InsertDoctypedata", body2, { responseType: 'json' });
  }
  updatedoctypedata(formdata: any): Observable<any> {

    var body = {

      "context": "To logout",
      "user_uuid": sessionStorage.getItem("uuid"),
      "formdata": JSON.stringify(formdata),
      "role_name": sessionStorage.getItem("role_name")
    }

    var body2 = this.encriptionMethodnewRSAandAES(JSON.stringify(body))

    return this.http.post(environment.APIEndpoint + "/api/trust/master/updatedoctypedata", body2, { responseType: 'json' });
  }


  updateUserdata(formdata: any): Observable<any> {

    var body = {

      "context": "To logout",
      "user_uuid": sessionStorage.getItem("uuid"),
      "formdata": JSON.stringify(formdata),
      "role_name": sessionStorage.getItem("role_name")
    }

    var body2 = this.encriptionMethodnewRSAandAES(JSON.stringify(body))

    return this.http.post(environment.APIEndpoint + "/api/trust/master/updateUserdata", body2, { responseType: 'json' });
  }
  updatetenantdata(formdata: any): Observable<any> {

    var body = {

      "context": "To logout",
      "user_uuid": sessionStorage.getItem("uuid"),
      "formdata": JSON.stringify(formdata),
      "role_name": sessionStorage.getItem("role_name")
    }

    var body2 = this.encriptionMethodnewRSAandAES(JSON.stringify(body))

    return this.http.post(environment.APIEndpoint + "/api/trust/master/updatetenantdata", body2, { responseType: 'json' });
  }

  updatestatus(formdata: any): Observable<any> {

    var body = {

      "context": "To logout",
      "user_uuid": sessionStorage.getItem("uuid"),
      "formdata": JSON.stringify(formdata),
      "role_name": sessionStorage.getItem("role_name")
    }

    var body2 = this.encriptionMethodnewRSAandAES(JSON.stringify(body))

    return this.http.post(environment.APIEndpoint + "/api/trust/master/updatestatus", body2, { responseType: 'json' });
  }

  fetchVisibility(documnettype: any): Observable<any> {

    var body = {

      "context": "To logout",
      "user_uuid": sessionStorage.getItem("uuid"),
      "documnettype": documnettype,
      "role_name": sessionStorage.getItem("role_name")
    }

    var body2 = this.encriptionMethodnewRSAandAES(JSON.stringify(body))

    return this.http.post(environment.APIEndpoint + "/api/trust/master/fetchVisibility", body2, { responseType: 'json' });
  }

  fetchtenant(): Observable<any> {

    var body = {

      "context": "To logout",
      "user_uuid": sessionStorage.getItem("uuid"),
      "role_name": sessionStorage.getItem("role_name")

    }

    var body2 = this.encriptionMethodnewRSAandAES(JSON.stringify(body))

    return this.http.post(environment.APIEndpoint + "/api/trust/master/fetchtenant", body2, { responseType: 'json' });
  }

  insertTenantData(formdata: any): Observable<any> {

    var body = {

      "context": "To logout",
      "user_uuid": sessionStorage.getItem("uuid"),
      "formdata": JSON.stringify(formdata),
      "role_name": sessionStorage.getItem("role_name")
    }

    var body2 = this.encriptionMethodnewRSAandAES(JSON.stringify(body))

    return this.http.post(environment.APIEndpoint + "/api/trust/master/insertTenantData", body2, { responseType: 'json' });
  }

  insertUserData(formdata: any): Observable<any> {

    var body = {

      "context": "To logout",
      "user_uuid": sessionStorage.getItem("uuid"),
      "formdata": JSON.stringify(formdata),
      "role_name": sessionStorage.getItem("role_name")
    }

    var body2 = this.encriptionMethodnewRSAandAES(JSON.stringify(body))

    return this.http.post(environment.APIEndpoint + "/api/trust/master/insertUserData", body2, { responseType: 'json' });
  }

  uploaddoc(formdata, file: File): Observable<any> {
    let reqParams = {
      "formdata": JSON.stringify(formdata),
      "user_uuid": sessionStorage.getItem("uuid"),
      "context": "Cloud Configuration Page - post -> To insert new Key Dependency"
    }
    var body2 = this.encriptionMethodnewRSAandAES(JSON.stringify(reqParams))
    const formData = new FormData();
    formData.append('file', file)
    formData.append('reqParams', JSON.stringify(body2))
    return this.http.post<any>(environment.APIEndpoint + "/api/trust/master/uploaddoc", formData, { responseType: 'json' });
  }

  downloadPdfFromByteString(byteString: string, filename: string): void {
    // Convert base64 string to a Uint8Array
    const byteCharacters = atob(byteString);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    // Create a Blob from the byte array
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    // Create a URL for the Blob
    const url = URL.createObjectURL(blob);

    // Create a link element
    const link = document.createElement('a');
    link.href = url;
    console.log("url", url)

    link.download = filename;

    // Append the link to the body
    document.body.appendChild(link);

    // Programmatically click the link to trigger the download
    link.click();

    // Clean up
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  base64ToHtml(base64String: string): string {
    // Decode base64 string to binary string
    const binaryString = atob(base64String);

    // Convert binary string to Uint8Array
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    // Convert Uint8Array to string
    const decoder = new TextDecoder('utf-8');
    return decoder.decode(bytes);
  }


  createBlobUrl(blob: Blob): string {
    return URL.createObjectURL(blob);
  }

  fetchAndDisplayBlob(byteString: string, filename: string) {

    const byteCharacters = atob(byteString);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    // Create a Blob from the byte array
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    // Create a URL for the Blob
    const url = URL.createObjectURL(blob);

    // Create a link element
    const link = document.createElement('a');
    link.href = url;
    console.log("url", url)

    return url;
    // this.http.get(url, { responseType: 'blob' }).subscribe(blob => {
    //   return URL.createObjectURL(blob);
    // });
  }

  // ngOnDestroy() {
  //   // Clean up Blob URL when component is destroyed
  //   if (this.blobUrl) {
  //     URL.revokeObjectURL(this.blobUrl);
  //   }
  // }
  getDocumentsListFromCategory(docType): Observable<any> {
    let body = {
      "user_uuid": sessionStorage.getItem("uuid"),
      "context": "To Fetch the document list based on document category",
      "docType": docType,
      "role_name": sessionStorage.getItem("role_name")
    }
    console.log('service');
    let body2 = this.encriptionMethodnewRSAandAES(JSON.stringify(body))
    return this.http.post(environment.APIEndpoint + "/api/trust/master/getPrivateDocCategeryDetailsByDocType", body2)
  }

  getPublicDocCategeryDetailsByDocType(docType): Observable<any> {
    let body = {

      "context": "To Fetch the document list based on document category",
      "docType": docType,
      "user_uuid": sessionStorage.getItem("uuid"),
      "role_name": sessionStorage.getItem("role_name")
    }
    console.log('service');
    let body2 = this.encriptionMethodnewRSAandAES(JSON.stringify(body))
    return this.http.post(environment.APIEndpoint + "/api/trust/master/getPublicDocCategeryDetailsByDocType", body2)
  }

  getroledeatils(): Observable<any> {
    let body = {
      "user_uuid": sessionStorage.getItem("uuid"),
      "context": "To Fetch the document list based on document category",
      "role_name": sessionStorage.getItem("role_name")

    }

    let body2 = this.encriptionMethodnewRSAandAES(JSON.stringify(body))
    return this.http.post(environment.APIEndpoint + "/api/trust/loginui/getroledeatils", body2)
  }

  updatedoc(formdata, file: File): Observable<any> {
    let reqParams = {
      "formdata": JSON.stringify(formdata),
      "user_uuid": sessionStorage.getItem("uuid"),
      "context": "Cloud Configuration Page - post -> To insert new Key Dependency",
      "role_name": sessionStorage.getItem("role_name")
    }
    var body2 = this.encriptionMethodnewRSAandAES(JSON.stringify(reqParams))
    const formData = new FormData();
    formData.append('file', file)
    formData.append('reqParams', JSON.stringify(body2))
    return this.http.post<any>(environment.APIEndpoint + "/api/trust/master/updatedoc", formData, { responseType: 'json' });
  }

  sentdetails(email_id: any, user_id: any) {
    let body = {
      "user_uuid": sessionStorage.getItem("uuid"),
      "context": "To Fetch the document list based on document category",
      "email_id": email_id,
      "user_id": user_id,
      "role_name": sessionStorage.getItem("role_name")

    }

    let body2 = this.encriptionMethodnewRSAandAES(JSON.stringify(body))
    return this.http.post(environment.APIEndpoint + "/api/trust/master/sentdetails", body2)
  }

  fetchRoleedetails(): Observable<any> {
    let body = {
      "user_uuid": sessionStorage.getItem("uuid"),
      "context": "To Fetch the document list based on document category",
      "role_name": sessionStorage.getItem("role_name")

    }

    let body2 = this.encriptionMethodnewRSAandAES(JSON.stringify(body))
    return this.http.post(environment.APIEndpoint + "/api/trust/master/fetchRoleedetails", body2)
  }

  fetchRoleedetailsuser(): Observable<any> {
    let body = {
      "user_uuid": sessionStorage.getItem("uuid"),
      "context": "To Fetch the document list based on document category",
      "role_name": sessionStorage.getItem("role_name")

    }

    let body2 = this.encriptionMethodnewRSAandAES(JSON.stringify(body))
    return this.http.post(environment.APIEndpoint + "/api/trust/master/fetchRoleedetailsuser", body2)
  }

  fetchTenantName(): Observable<any> {
    let body = {
      "user_uuid": sessionStorage.getItem("uuid"),
      "context": "To Fetch the document list based on document category",
      "role_name": sessionStorage.getItem("role_name")

    }

    let body2 = this.encriptionMethodnewRSAandAES(JSON.stringify(body))
    return this.http.post(environment.APIEndpoint + "/api/trust/master/fetchTenantName", body2)
  }


}

export const regexPattern = {
  alphanumericWithUnderscoreAndHyphen: /^[a-zA-Z0-9_\s-]+$/,
}